// import EntypoIcon from '@expo/vector-icons/Entypo'

// import BackIcon from '../../components/BackIcon'
// import XTabNavIcon from '../../components/XTabNavIcon'

import BaseUICreateStoreWebsiteView from 'xui/modules/storeWebsite/BaseUICreateStoreWebsiteView'

export default class CreateStoreWebsiteView extends BaseUICreateStoreWebsiteView {}
